function colorToString(color) {
  return color && color.swatch ? `hsla(${color.swatch.hue},${color.swatch.saturation}%,${color.swatch.lightness}%,${color.alpha})` : "";
}
export {
  colorToString
};
//# sourceMappingURL=colorToString.js.map